import React from "react";
import Me from "../assets/me.jpg";
import { FaDownload } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { AiFillLinkedin } from "react-icons/ai";
import { experienceConfig } from "../config/resume/experienceConfig";
import { technicalSkillsConfig } from "../config/resume/technicalSkillsConfig";
import { transferrableSkillsConfig } from "../config/resume/transferrableSkillsConfig";
import { AnimatedHeader } from "../components/AnimateHeader";

const Resume = () => {
  return (
    <div id="resume" className="container">
      <div
        className="projects__text-container"
        data-aos="fade-up"
        data-aos-delay="500"
      >
        <AnimatedHeader className={"projects__header"} headerText={"Resume"} />
      </div>
      <div className="resume__wrapper">
        <div className="resume__grid" data-aos="fade-up" data-aos-delay="500">
          <div className="resume__image">
            <img src={Me} alt="" />
          </div>
          <div>
            <div className="resume__name playfair">Adrian Garbowski</div>
            <div className="resume__title lato">Frontend Developer</div>
            <div className="resume__contact--info">
              <div>
                <FaDownload />
                <a
                  className="resume__link"
                  href="/resume-eng.pdf"
                  target="_blank"
                >
                  Download resume
                </a>
              </div>
              <div>
                <MdEmail />
                <a
                  className="resume__link"
                  href="mailto:me@adriangarbowski.com"
                >
                  Email
                </a>
              </div>
              <div>
                <AiFillLinkedin />
                <a
                  className="resume__link"
                  href="https://www.linkedin.com/in/adrian-garbowski/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Linkedin
                </a>
              </div>
            </div>
            <div>
              A highly driven 20-year-old frontend developer leveraging advanced
              technical, problem-solving, and communication skills to craft
              innovative and user-centric web solutions. Currently dedicated to
              enhancing digital experiences through impactful website
              development.
            </div>
          </div>
        </div>

        <div className="resume__grid" data-aos="fade-up" data-aos-delay="500">
          <div className="resume__title--description">Education</div>
          <div>
            <div className="resume__education--wrapper">
              <div className="resume__education">
                <div className="resume__job--name">
                  Warsaw University of Technology
                </div>
                <div>Bachelor of Computer Science</div>
              </div>
              <div className="resume__job--date">Oct 2023 - Current</div>
            </div>
            <div className="resume__education--wrapper">
              <div className="resume__education">
                <div className="resume__job--name">
                  MERN Fullstack Udemy Courses
                </div>
                <ul className="resume__list-wrapper">
                  <li>
                    Finished 500+ hours of Video Courses by Academind and Jonas
                    Schmedtmann
                  </li>
                  <li>
                    Certificates in: HTML, CSS & Sass, JavaScript, React,
                    Node.js, Express.js and MongoDB
                  </li>
                </ul>
              </div>
              <div className="resume__job--date">Dec 2021 - Oct 2022</div>
            </div>
            <div className="resume__education--wrapper">
              <div className="resume__education">
                <div className="resume__job--name">
                  Karol Marcinkowski Highschool No. 1 in Poznań
                </div>
                <div>Extended Math, IT and English subjects</div>
                <div style={{ marginBottom: "0.5rem", marginTop: "0.25rem" }}>
                  GPA:
                </div>
                <ul className="resume__list-wrapper">
                  <li>Extended Mathematics: 96%</li>
                  <li>Extended IT: 96%</li>
                  <li>Extended English: 92%</li>
                </ul>
              </div>
              <div className="resume__job--date">Sep 2019 - May 2023</div>
            </div>
          </div>
        </div>

        <div className="resume__grid" data-aos="fade-up" data-aos-delay="500">
          <div className="resume__title--description">Experience</div>
          <div>
            {experienceConfig.map((experience, index) => (
              <div className="resume__job--wrapper" key={index}>
                <div className="resume__job">
                  <div>
                    <div className="resume__job--name">{experience.name}</div>
                    <div className="resume__job--description">
                      {experience.title}
                    </div>
                  </div>
                  <div className="resume__job--date">{experience.date}</div>
                </div>

                <ul className="resume__list-wrapper">
                  {experience.description.map((description, index) => (
                    <li key={index}>{description}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="resume__grid" data-aos="fade-up" data-aos-delay="500">
          <div className="resume__title--description">Technical Skills</div>
          <div>
            <div>
              <ul className="resume__list-wrapper resume__skills--list-wrapper">
                {technicalSkillsConfig.map((technicalSkills, index) => (
                  <li key={index}>{technicalSkills}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="resume__grid" data-aos="fade-up" data-aos-delay="500">
          <div className="resume__title--description">Transferrable Skills</div>
          <div>
            <div>
              <ul className="resume__list-wrapper resume__skills--list-wrapper">
                {transferrableSkillsConfig.map((transferrableSkills, index) => (
                  <li key={index}>{transferrableSkills}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div
          className="resume__grid resume__bottom"
          data-aos="fade-up"
          data-aos-delay="500"
        >
          <div className="resume__title--description">References</div>
          <div>Available Upon request</div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
